<template>
    <div class="layout__position-left layout__width-100">

        <!--{{this.orders[0]}}-->

        <el-form :model="searchParams" status-icon :rules="rules" ref="searchParams">
            <div class="layout__padding-clear text__align-center layout__width-100">

                <div class="layout__width-50 layout__position-left">
                    <div class="layout__padding-0-20">
                    <el-form-item prop="orderFreeText" class="layout__padding-0-20">
                        <p class="layout__padding__top-10px text__align-left">Freetext Search</p>
                        <el-input placeholder="Search" v-model="searchParams.orderFreeText"
                                  clearable
                                  autofocus></el-input>
                    </el-form-item>
                    </div>
                </div>
                <div class="layout__width-50 layout__position-left">
                    <el-form ref="jobStatus" class="layout__padding-0-20">
                        <p class="layout__padding__top-10px text__align-left">Status</p>
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.orderStatus" placeholder="Order Status" clearable>
                                <el-option v-for="status in ravensworth.orderStatus.options"
                                           :key="status.id"
                                           :label="status.text"
                                           :value="status.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__width-50 layout__position-left">
                    <el-form ref="products" class="layout__padding-0-20">
                        <p class="layout__padding__top-10px text__align-left">Category</p>
                        <el-form-item prop="orderCategory">
                            <el-select v-model="searchParams.orderCategory" placeholder="Category" clearable filterable>
                                <el-option v-for="product in ravensworth.orderCategory.options"
                                           :key="product.id"
                                           :label="product.name"
                                           :value="product.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__width-50 layout__position-left">
                    <el-form ref="products" class="layout__padding-0-20">
                        <p class="layout__padding__top-10px text__align-left">Product</p>
                        <el-form-item prop="orderSource">
                            <el-select v-model="searchParams.orderSource" placeholder="Product" clearable filterable>
                                <el-option v-for="product in ravensworth.orderSource.options"
                                           :key="product.id"
                                           :label="product.name"
                                           :value="product.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__width-50 layout__position-left">
                    <el-form ref="products" class="layout__padding-0-20">
                        <p class="layout__padding__top-10px text__align-left">Assigned To</p>
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.assignment" placeholder="Assigned To" clearable filterable
                                       :disabled="this.searchParams.orderSource !== 'BESPOKE'">
                                <el-option v-for="user in users"
                                           :key="user.name"
                                           :label="user.name"
                                           :value="user.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__width-50 layout__position-left">
                    <el-form ref="products" class="layout__padding-0-20">
                        <p class="layout__padding__top-10px text__align-left">Territory</p>
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.territory" placeholder="Territory" clearable filterable
                                       :disabled="this.searchParams.orderSource === 'BESPOKE' && this.view === 'bespoke'">
                                <el-option v-for="territory in territories"
                                           :key="territory.name"
                                           :label="territory.name"
                                           :value="territory.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__width-50 layout__position-left">
                    <div class="layout__padding-0-20">
                    <el-form-item prop="salesDateRange">
                        <p class="layout__padding__top-10px">To - From Date</p>
                        <el-date-picker
                                v-model="searchParams.salesDateRange"
                                type="daterange"
                                range-separator="To"
                                start-placeholder="Start date"
                                end-placeholder="End date"
                                format="dd-MM-yyyy"
                                value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    </div>
                </div>
                <div class="layout__width-50 layout__position-left">
                    <el-form ref="products" class="layout__padding-0-20">
                        <p class="layout__padding__top-10px text__align-left">Date Filter</p>
                        <el-form-item prop="orderSource">
                            <el-select v-model="searchParams.dateFilter" placeholder="Date Filter" clearable filterable>
                                <el-option v-for="product in ravensworth.dateFilter.options"
                                           :key="product.id"
                                           :label="product.name"
                                           :value="product.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

        </el-form>








        <div class="layout__padding-0-20">
            <div class="layout__padding-clear layout__width-50">
                <el-button class="button-red button__base layout__width-100 layout__margin-40-0" id="getOrders"
                           v-on:click="validateAdminSearch('searchParams')">Search Orders
                </el-button>
            </div>

            <el-button :disabled="false" class="button-teal layout__position-right button__base__admin layout__width-200px"
                       id="downloadAllResults" v-on:click="adminDownload()" :loading="downloadLoading">Download Data
                (csv)
            </el-button>

            <div class=" layout__position-right layout__padding-5-10">
                <p>{{this.resultsCount}} Results Found</p>
            </div>
        </div>

    </div>

</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';
    import moment from 'moment';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';

    export default {
        name: "adminOrdersSearch",
        mixins: [axios, dataFormatter, backing, csvDownloadHelper],
        props: {
            searchParams: Object,
            orders: Array,
            loading: Boolean,
            resultsCount: String
        },
        data() {
            return {
                // queryRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/adminSearchorders?`,
                parameters: [],
                serviceRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search`,
                admin_search: '/adminSearch?',
                admin_download: '/adminDownload?',
                downloadLoading: false,
                territories: [],
                users: [],
                exportDate: 'admin_orders_' + new Date().toLocaleDateString('en-GB') + '.csv',
                pickerOptions: {
                    shortcuts: [{
                        text: 'Today',
                        onClick(picker) {
                            const start = new Date();
                            start.setTime(start.getTime());
                            picker.$emit('pick', start);
                        }
                    },
                        {
                            text: 'Last week',
                            onClick(picker) {
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', start);
                            }
                        },
                        {
                            text: 'Last month',
                            onClick(picker) {
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                console.log(start.toLocaleDateString('en-GB'))
                                picker.$emit('pick', start);
                            }
                        },
                        {
                            text: 'Last 3 months',
                            onClick(picker) {
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', start);
                            }
                        }]
                },
                rules: {
                    salesDateRange: [{
                        required: true,
                        message: 'To/From Dates required',
                        trigger: 'blur'
                    }]
                }
            }
        },
        computed: {
            assignedTo() {
                return this.$parent.searchParams.orderSource;
            }
        },
        watch: {
            assignedTo() {
                console.log(this.$parent.searchParams.orderSource)
                if (this.$parent.searchParams.orderSource !== 'BESPOKE') {
                    this.$parent.searchParams.assignment = null
                }
            }
        },
        created() {
            this.isUserAuthorised();

            this.searchParams.salesDateRange[0] = moment().subtract(7, 'days').format('YYYY-MM-DD');
            this.searchParams.salesDateRange[1] = moment().format('YYYY-MM-DD');

            if (window.sessionStorage.getItem('_adminOrdersSearch') !== null && typeof window.sessionStorage.getItem('_adminOrdersSearch') !== 'undefined') {
                this.$parent.searchParams = JSON.parse(window.sessionStorage.getItem('_adminOrdersSearch'))
            }

            const getTerritories = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/territoryLookup?`
            Axios.get(getTerritories, this.returnHeaderUsingToken())
                .then(response => {
                    this.territories = response.data.value
                })

            const getUsers = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/userLookup?`
            Axios.get(getUsers, this.returnHeaderUsingToken())
                .then(response => {
                    console.log('rifat')
                    console.log(response.data.value)
                    this.users = response.data.value
                })

            this.adminSearch()
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_adminOrdersSearch', JSON.stringify(this.$parent.searchParams));
        },

        methods: {
            constructQueryString() {

                this.parameters = []
                let searchTerms = Object.assign({}, this.$parent.searchParams)
                console.log('real ', this.$parent.searchParams)
                console.log('copied ', searchTerms)

                if (searchTerms.orderFreeText !== '') {
                    this.parameters.push('freetext=' + searchTerms.orderFreeText)
                }

                if (searchTerms.territory !== null && searchTerms.territory !== "") {
                    this.parameters.push('territory=' + searchTerms.territory)
                }

                if ((searchTerms.assignment !== '' && searchTerms.assignment !== null) && searchTerms.orderSource === 'BESPOKE') {
                    this.parameters.push('assignedTo=' + searchTerms.assignment)
                }

                if (searchTerms.orderSource !== null && searchTerms.orderSource !== '' && searchTerms.orderSource !== 'ANY PRODUCT') {
                    this.parameters.push('source=' + searchTerms.orderSource)
                }

                if (searchTerms.orderCategory !== null && searchTerms.orderCategory !== '' && searchTerms.orderCategory !== 'ANY CATEGORY') {
                    this.parameters.push('category=' + searchTerms.orderCategory)
                }

                if (searchTerms.orderStatus !== null && searchTerms.orderStatus !== '' && searchTerms.orderStatus !== 'ANY STATUS') {
                    if (searchTerms.orderStatus !== 'FOC') {
                        this.parameters.push('status=' + searchTerms.orderStatus)
                    } else {
                        this.parameters.push('foc=FOC')
                    }

                }

                this.parameters.push('startDate=' + searchTerms.salesDateRange[0])
                this.parameters.push('endDate=' + moment(searchTerms.salesDateRange[1], 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD'))

                if (searchTerms.dateFilter === 'ORDERED') {
                    this.parameters.push('ordered=ordered')
                } else {
                    this.parameters.push('created=created')
                }




            },
            adminSearchPagination() {
                let search_paginated = this.serviceRouteUrl + this.admin_search + this.parameters.join('&') + '&skip=' + this.$parent.searchParams.skip + '&top=' + this.$parent.searchParams.top
                console.log(search_paginated)

                this.$parent.loading = true
                Axios.get(search_paginated, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)
                        this.$parent.orders = []
                        this.$parent.orders = response.data.value
                        this.$parent.loading = false
                    })
                    .catch(error => {
                        this.$parent.loading = false
                        this.$parent.orders = []
                    })
            },
            adminSearch() {

                //    TODO: the admin search always executes 2 querys a count (on the full query) and a query to return paginated resultsconst
                this.constructQueryString()

                this.adminSearchPagination()

                let search_counts = this.serviceRouteUrl + this.admin_search + this.parameters.join('&') + '&count=true&top=0'


                console.log(search_counts)

                Axios.get(search_counts, this.returnHeaderUsingToken())
                    .then(response => {
                        this.$parent.resultsCount = response.data['@odata.count']
                        this.$parent.loading = false
                    })
                    .catch(error => {
                        this.$parent.loading = false
                        this.$parent.resultsCount = 0
                    })


            },
            adminDownload() {

                //    TODO: will select a different set of values and expand a 2 tables for the exported result set
                this.downloadLoading = true
                this.constructQueryString()

                let search_download = this.serviceRouteUrl + this.admin_search + this.parameters.join('&')

                Axios.get(search_download, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response.data.value.length)

                        let fields = [];

                        if (JSON.parse(this.returnCookie('_role')).includes('RpsBilling')) {
                            fields = [
                                {label: 'Order_Record_Id', value: 'id'},
                                {label: 'Order_Id', value: 'orderId'},
                                {label: 'Ordered', value: (row, field) => this.formatDateTime(row)},
                                {label: 'Source_Id', value: 'sourceId'},
                                {label: 'Source_Type', value: 'sourceType'},
                                {label: 'Job_Id', value: 'jobId'},
                                {label: 'Type', value: 'type'},
                                {label: 'ProductCat1', value: 'category'},
                                {label: 'Status', value: 'status'},
                                {label: 'Branch', value: 'branch'},
                                {label: 'Name', value: 'name'},
                                {label: 'Job_Name', value: 'jobName'},
                                {label: 'Quantity', value: 'quantity'},
                                {label: 'Product', value: 'productCode'},
                                {label: 'Press', value: 'press'},
                                {label: 'Style', value: 'style'},
                                {label: 'Paper', value: 'paperWeight'},
                                {label: 'Finishing', value: 'finishing'},
                                {label: 'Value', value: 'billNetTotal'},
                                {label: 'Bill_Status', value: 'billStatus'},
                                {label: 'Territory', value: 'customer.territory'},
                                {label: 'Assigned_To', value: 'bespokeSource.user'},
                                {label: 'Zendesk_Id', value: 'bespokeSource.zdTicket'}
                            ];
                        } else {
                            fields = [
                                {label: 'Order_Record_Id', value: 'id'},
                                {label: 'Order_Id', value: 'orderId'},
                                {label: 'Ordered', value: (row, field) => this.formatDateTime(row)},
                                {label: 'Source_Id', value: 'sourceId'},
                                {label: 'Source_Type', value: 'sourceType'},
                                {label: 'Job_Id', value: 'jobId'},
                                {label: 'Type', value: 'type'},
                                {label: 'Category', value: 'productCat1'},
                                {label: 'Category', value: 'productCat3'},
                                {label: 'Status', value: 'status'},
                                {label: 'Branch', value: 'branch'},
                                {label: 'Name', value: 'name'},
                                {label: 'Job_Name', value: 'jobName'},
                                {label: 'Quantity', value: 'quantity'},
                                {label: 'Product', value: 'productCode'},
                                {label: 'Press', value: 'press'},
                                {label: 'Style', value: 'style'},
                                {label: 'Paper', value: 'paperWeight'},
                                {label: 'Finishing', value: 'finishing'},
                                {label: 'Value', value: 'billNetTotal'},
                                {label: 'Bill_Status', value: 'billStatus'},
                                {label: 'Territory', value: 'customer.territory'},
                                {label: 'Assigned_To', value: 'bespokeSource.user'},
                                {label: 'Zendesk_Id', value: 'bespokeSource.zdTicket'}
                            ];
                        }

                        this.downloadCsv(this.exportDate, fields, response.data.value)
                        this.downloadLoading = false
                    })
                    .catch(error => {

                    })

            },

            validateAdminSearch(searchParams) {


                this.$refs[searchParams].validate((valid) => {
                    if (valid) {
                        this.$parent.searchParams.skip = 0;
                        this.$parent.searchParams.currentPage = 1;
                        this.adminSearch()
                    } else {
                        return false;
                    }
                })
            },






            getResults() {
                //    todo this method will have the counts call and the limited results

                this.constructQueryString()

                let getResults = this.queryRouteUrl + this.parameters.join('&') + '&skip=' + this.$parent.searchParams.skip + '&top=' + this.$parent.searchParams.top
                console.log('results')
                console.log(getResults)

                this.$parent.loading = true
                Axios.get(getResults, this.returnHeaderUsingToken())
                    .then(response => {
                        this.$parent.orders = []
                        this.$parent.orders = response.data.value
                        // console.log(this.$parent.orders)
                        console.log(this.$parent.orders.length)
                        this.$parent.loading = false
                    })
                    .catch(error => {
                        this.$parent.loading = false
                        // if (error.response.status === 500) {
                        this.$parent.orders = []
                        // }
                    })

                let getCounts = this.queryRouteUrl + this.parameters.join('&') + '&count=true&top=0'
                console.log('count')
                console.log(getCounts)

                // this.$parent.loading = true // todo this might be an issue with the true and false
                Axios.get(getCounts, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response.data)
                        console.log(response.data['@odata.count'])
                        this.$parent.resultsCount = response.data['@odata.count']

                        // console.log(this.$parent.customers.length)
                        this.$parent.loading = false
                    })
                    .catch(error => {
                        this.$parent.loading = false
                        // if (error.response.status === 500) {
                        // }
                    })
            },

            getOrders(searchParams) {


                this.$refs[searchParams].validate((valid) => {
                    if (valid) {
                        this.$parent.searchParams.skip = 0;
                        this.$parent.searchParams.currentPage = 1;
                        this.getResults()
                    } else {
                        return false;
                    }
                })
            }
        }
    };
</script>